
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/actions.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-actions-demo-toc","docs-flow-components-actions-demo-actions","docs-flow-components-actions-demo-before-submit","docs-flow-components-actions-demo-yourself"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/actions.md?type=demo')
};